import apiFetch from '../apiFetch'

export default function (token, optionType) {
  const queryParamsArray = [
    optionType ? `type=${optionType}` : null
  ]

  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )

  return apiFetch({ endPoint: 'Document/GetAllDocumentDataOptions' + queryParams, method: 'GET', body: null, token: token })
}
